module.exports = __webpack_public_path__ + "static/19-keflavik-c8774f0cfe6505ddbf1b17eb57cb2b8e.jpg";